module.exports = __webpack_public_path__ + "img/backward.b70e25e5.png";